import { renderTimeViewClock, TimePicker } from "@mui/x-date-pickers"
import { makeStyles } from "tss-react/mui"
import { DateTime } from "luxon"

type StandardTimePickerProps = {
    dateTime: DateTime
    setDateTime: (value: React.SetStateAction<DateTime>) => void
    label: string
    minTime?: DateTime | undefined
    isMinutesStep?: boolean
}
const useStyles = makeStyles()((theme) => ({
    timeFilter: {
        width: "auto",
        maxWidth: "8rem",
    },
    timePickerIconButton: {
        "& .MuiSvgIcon-root": {
            fontSize: "1.3rem",
        },
    },
}))

export function StandardTimePicker({
    label,
    dateTime,
    setDateTime,
    minTime,
    isMinutesStep = true,
}: StandardTimePickerProps) {
    const { classes } = useStyles()

    return (
        <TimePicker
            minTime={minTime}
            label={label}
            viewRenderers={{
                hours: renderTimeViewClock,
                minutes: renderTimeViewClock,
                seconds: renderTimeViewClock,
            }}
            minutesStep={isMinutesStep ? 5 : undefined}
            value={dateTime}
            onChange={(newValue) => {
                if (newValue) {
                    setDateTime(newValue)
                }
            }}
            slotProps={{
                openPickerButton: { className: classes.timePickerIconButton },
            }}
            className={classes.timeFilter}
        />
    )
}
